import { MouseEvent, useState } from 'react';

import { Box, Tooltip } from '@material-ui/core';
import { Button } from '@material-ui/core';

export const ChatDetailSettingsButton = ({
  isAutomatedChat,
  title,
  onClick,
  disabledReason,
}: {
  isAutomatedChat: boolean;
  title: string;
  onClick: () => void;
  disabledReason?: string;
}) => {
  return (
    <Tooltip title={disabledReason || ''} placement="bottom">
      <Box>
        <Button
          size="small"
          style={{ width: '100%' }}
          onClick={onClick}
          disabled={isAutomatedChat}
          color="primary"
          variant="outlined"
        >
          {title}
        </Button>
      </Box>
    </Tooltip>
  );
};
